import {ComponentFactoryResolver, Component, OnInit, Input, Pipe, PipeTransform, OnChanges, SimpleChanges, Inject, AfterViewInit, HostListener, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { trigger, state, animate, transition, style } from '@angular/animations';
import { ViewChild, ElementRef } from '@angular/core';
import { GlobalpopupComponent } from '../../shared/globalpopup/globalpopup.component';
import { BookdetailsComponent } from '../popups/bookdetails/bookdetails.component';
import { CreatedBookInfoComponent } from '../popups/createdBookInfo/createdBookInfo.component'
import { BooksFilterComponent } from '../popups/booksFilter/booksFilter.component';
import { bookCategories, bookCategoeyEnums } from '../../shared/models/shelfEnums';
import { Sort } from '@angular/material';
import * as _ from "lodash";
import { Constants } from '../../shared/models/constants';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Shelf } from '../../shared/models/shelf';
import { ShelfPouchDb } from '../shelf.pouchdb.service';
import { Component_interactionService } from '../../component_interaction.service';
import { IS_ElectronService } from '../../shared/IS_Electron.service';

import { GlobalPopupAppendDirective } from '../../shared/directives/globalPopupAppend.directive';
import { GlobalPopupAppendComponent } from '../../shared/directives/globalPopupAppend.component';
import { ExportviewComponent } from '../../bookShared/popups/export/export.component';
import { ExportService } from '../../bookShared/popups/export/exoprt.service';

@Component({
  selector: 'app-all',
  templateUrl: './all.component.html',
  styleUrls: ['./all.component.css']
})
export class AllComponent implements OnInit {
  @ViewChild('panelRecent', { read: ElementRef }) public panelRecent: ElementRef;
  @Input() data: any;
  @ViewChild('OtherBookTypeRowParent') parentEle: ElementRef;
  @ViewChild('repeatingBookTypes') repeatingBookTypes: ElementRef;
  @ViewChild(GlobalPopupAppendDirective) globalpopupHost: GlobalPopupAppendDirective;

  availableViewableWidth = 20;
  totalScrollbarWidth;

  @HostListener('window:resize') onResize() {
    this.updateScrollNavbars();
  }

  Math: any;
  public booksList;
  public bookTypes = ['Recent'];
  public purchasesViewType: string = "grid";
  public hideArrowButtons: boolean = false;
  public tempEle;
  public typeOfBook: any;
  public showOverlayDivPdf = false;
  public pdfObj = {};
  public sliderWidth = 744;
  public pdfPage = 0;
  public showGridView = false;
  public showAllGridView = true;
  public selectedGridIndex = undefined;
  public gridToggleIcon = 'icon-BottomButton';
  selBookDetals;
  allRecentFiles = [];
  popupParams: any = {
    height: 400,
    width: 300,
    direction: "left",
    arrowPos: 50,
    showPopup: false,
    loadDirective: '',
    curComp: this,
    isBooksFilter: "books",
  };
  booksData = {
    'bookList': [],
    'name': '',
  };
  bookCategoryTypes: any;
  bookCategoeyEnums: any
  globalPopupPara = <any>{};
  counter = Array;
  showRecentGridView = true;
  showAllShelfs = true;
  filterBooksArr = [];
  showExportPopup = false;
  showExportInnerPopup = false;
  sortedData;
  public prevStateArr;
  public templates;
  bookTemplates: any;
  draggedBook;
  droppedOnBook;
  lastCreatedShelf;
  draggingFrom;
  draggedBookFrom;
  draggedBookFromId;
  droppedBookAt;
  bookInfoShelfId;
  myTemplatesArr;
  subscription;
  shelfDataSubscription;
  allFiltersList = [];
  filterUpdatingState = true;
  avoidingFastSwitching = true;
  closeGlobalExportSubscription: any;
  public purchasesInd;
  public purchasesBooks = [];


  constructor(private exportService: ExportService, private componentFactoryResolver: ComponentFactoryResolver, private ele: ElementRef, private cdr: ChangeDetectorRef, public dialog: MatDialog, public pouchservice: ShelfPouchDb, private Component_interactionService: Component_interactionService, private ElectronService: IS_ElectronService) {
    this.Math = Math;
  }

  ngOnInit() {
    var self = this;
    this.bookCategoeyEnums = bookCategoeyEnums;
    this.bookCategoryTypes = bookCategories;

    if(!this.ElectronService.IS_ELECTRON){
      this.bookTemplates = Constants.getBookTemplatesArr();
      this.templates = Constants.getTemplates();
    }
    else{
      this.bookTemplates = Constants.getElectronBookTemplatesArr();
      this.templates = Constants.getElectronTemplates();
    }

    if (this.data.pouchData) {

      this.booksData.bookList = [];
      this.booksData.bookList = this.data.pouchData.data;
      this.booksData.name = this.data.pouchData.type;

    }
    if (this.data.pouchData.recentData) {

      this.allRecentFiles = this.data.pouchData.recentData;
      this.allRecentFiles =  _.filter(this.allRecentFiles, function (filter) { return filter != undefined })
    }


    //for test purpose

    this.purchasesInd = _.findIndex(self.booksData.bookList, function (o) { return o.shelfName == "Purchases"; });
    this.purchasesBooks = [];
    if (this.purchasesInd != -1) {
      this.purchasesBooks = self.booksData.bookList[this.purchasesInd].data;
    }

    let downloadingBooksCallback = setInterval(function () {

      if (self.ElectronService.downloadingBooksArray.length) {
        // console.log('downloadingBooksCallback running');
        self.purchasesBooks = self.booksData.bookList[self.purchasesInd].data;
        if (self.purchasesBooks.length) {
          for (let i = 0; i < self.purchasesBooks.length; i = i + 1) {
            // debugger;
            for (let j = 0; j < self.ElectronService.downloadingBooksArray.length; j = j + 1) {
              // debugger;
              if (self.purchasesBooks[i].bId == self.ElectronService.downloadingBooksArray[j].publishId) {
                // debugger;
                // console.log('downloadingBooksCallback condition true');
                // console.log(self.purchasesBooks[i].bId);
                self.purchasesBooks[i].isDownloading = true;
              }
            }

          }
        }

      }
      else {
        // console.log('downloadingBooksCallback cleared');
        if (self.purchasesBooks.length) {
          for (let i = 0; i < self.purchasesBooks.length; i = i + 1) {
            // debugger;
            self.purchasesBooks[i].isDownloading = false;
          }
        }
        clearInterval(downloadingBooksCallback);
      }

      // if (!self.cdr['destroyed']) {
      //   self.cdr.detectChanges();
      // }

    }, 500);
    //


    var myCompThis = parent.window.document['mycompthis'];
    this.myTemplatesArr = myCompThis.cteatedMytemplates;

    if (localStorage.allGridview != 'undefined' && localStorage.allGridview != undefined) {
      this.purchasesViewType = localStorage.allGridview;
    }

    if (localStorage.isCheckedRecents != undefined) {
      if (localStorage.isCheckedRecents == "true") {
        this.data.this.displayRecents = true;
      }

      else {

        this.data.this.displayRecents = false;
      }
    }

    
    if (this.subscription) this.subscription.unsubscribe();

    this.subscription = this.Component_interactionService.cast1.subscribe(data => {
      if (data.length != 0) {
        self.booksData.bookList = data.data;
        self.booksData.name = data.type;
        if (data.recentData) {
          this.allRecentFiles = data.recentData;
        }
      }
    });



    this.shelfDataSubscription = this.pouchservice.interaction.subscribe(data => {
      if(self.lastCreatedShelf){
        self.updateListOfShlefs(data);
      }
    })



    this.closeGlobalExportSubscription = this.exportService.closeGlobalExport$.subscribe(data => {

      if (data == "close") {

        self.showExportPopup = false;
      }

    })

  }


  ngAfterViewInit() {

  }

  ngAfterViewChecked() {
    if (this.ele.nativeElement.querySelector('.OtherBookTypeRowParent')) {
      this.availableViewableWidth = this.ele.nativeElement.querySelector('.OtherBookTypeRowParent').offsetWidth - 15;  // 15 is offset
      this.totalScrollbarWidth = this.ele.nativeElement.querySelector('.OtherBookTypeRowParent').scrollLeft;
      if (this.availableViewableWidth <= 0) {
        this.availableViewableWidth = this.ele.nativeElement.querySelector('.allToolBar').offsetWidth
      }
      localStorage.availableViewableWidth = this.availableViewableWidth;
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    this.booksData.bookList = changes.booksData.currentValue.booksList;
    for (var i = 0; i < this.booksData.bookList.length; i++) {
      if (this.bookTypes.indexOf(this.booksData.bookList[i].type) == -1) {
        this.bookTypes.push(this.booksData.bookList[i].type);
      }
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if(this.shelfDataSubscription){
      this.shelfDataSubscription.unsubscribe();
    }

    if (this.closeGlobalExportSubscription) this.closeGlobalExportSubscription.unsubscribe();


  }
  
    public exportGlobalData: any;

  closeExportPopup(event, state) {

    event.stopPropagation();
    if (state == true)
      this.showExportPopup = false;
  }

  manageExportPopup(data) {

    var obj = {
      'popupProps': {
        'bookDataObj': {},
        'bookObj': data,
        'pageCount': 1,
        'CE': false
      }
    }
    var self = this;

    if (data.bookCategory == 1) {

      obj.popupProps.CE = true;
    }

    this.pouchservice.getBookDataObjForExport(data).then(function (result) {

      obj.popupProps.bookDataObj = result[0];

      obj.popupProps['isGlobalExport'] = true;

      self.exportGlobalData = obj;

      setTimeout(() => {

        self.showExportInnerPopup = true;
      }, 100);
      self.showExportPopup = true;

    }).catch(function (err) {


    })

  }

  makeBookFav(obj, state) {

      var self = this;
      if (!this.avoidingFastSwitching) {
        return;
      } else {
        this.avoidingFastSwitching = false;
        setTimeout(function () {
          self.avoidingFastSwitching = true;
        }, 1000);
      }

    obj.isFav = !obj.isFav;
    this.pouchservice.updateFavBook(obj)
  }

  isRecentGridIconShow(){
    if((this.allRecentFiles.length * 170) > this.availableViewableWidth){
      return true;
    }else{
      return false;
    }
  }

  get flyInOut() {

    return 'in';

  }

  get animateHeight() {
    if (this.showGridView) {
      return 'extraHeight';
    } else {
      return 'normalHeight';
    }

  }

  toggleLeftSidenav() {

    // this.myApp.toggleLeftPanel();

    // this.myApp.isLeftnavbarShow = !this.myApp.isLeftnavbarShow;
  }

  toggle(): void {
    if (this.purchasesViewType == "grid") {
      this.purchasesViewType = "list";
      localStorage.allGridview = "list"
      this.prevStateArr = JSON.parse(JSON.stringify(this.booksData.bookList))

    } else if (this.purchasesViewType == "list") {
      this.purchasesViewType = "grid";
      localStorage.allGridview = "grid"
    }
  }

  displayPdfOverLay(pdf) {



    this.showOverlayDivPdf = true;
    // this.pdfObj = pdf;
    // this.sliderWidth = 744;
    // this.pdfPage = 0;
    this.typeOfBook = null;



    // this.SelectedSubType = undefined;   
    this.pdfObj = pdf;
    this.Component_interactionService.selectedBookData(pdf);
    // this.data.this.onBookClick(pdf);
    this.sliderWidth = 744;
    this.pdfPage = 0;

  }


  public onPrevious(evt, type: any): void {

    let dis;
    let temp;
    dis = this.tempEle.scrollLeft;
    temp = this.tempEle.scrollLeft - this.availableViewableWidth;

    // let scrollNavigation = this.tempEle.querySelectorAll('.booksNavigation');
    // let activeIndex;
    // for (let i = 0; i < scrollNavigation.length; i++) {
    //   if (scrollNavigation[i].classList.contains('activeScrollBar')) {
    //     activeIndex = i;
    //   }
    // }
    var prevEleParent = this.tempEle.closest('.OtherBookTypeRowParent');
    var prevEleClassList = prevEleParent.querySelector('.prevBooksIcon').classList;
    if(temp <= 0){
      prevEleClassList.add('hidePrevBooksIcon')
    }
    // if (scrollNavigation[activeIndex - 1]) {
    //   scrollNavigation[activeIndex].classList.remove('activeScrollBar');
    //   scrollNavigation[activeIndex - 1].classList.add('activeScrollBar');
    //   if ((activeIndex - 1) == 0) {
    //     prevEleClassList.add('hidePrevBooksIcon')
    //   }
    // }

    // else {
      // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
      // scrollNavigation[0].classList.add('activeScrollBar');
      
      // if (!this.ElectronService.IS_ELECTRON)
      //   this.tempEle.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      // else
      //   this.tempEle.scrollLeft = 0;
      // return;
    // }
   
  if (!this.ElectronService.IS_ELECTRON)
  this.tempEle.scrollTo({ left: temp, top: 0, behavior: 'smooth' });
else
  this.tempEle.scrollLeft = temp;

  }



  public onNext(evt, type: any): void {

    let dis;
    let temp;
    dis = this.tempEle.scrollLeft;
    temp = this.tempEle.scrollLeft + this.availableViewableWidth;

    // let scrollNavigation = this.tempEle.querySelectorAll('.booksNavigation');
    // let activeIndex;
    // for (let i = 0; i < scrollNavigation.length; i++) {
    //   if (scrollNavigation[i].classList.contains('activeScrollBar')) {
    //     activeIndex = i;
    //   }
    // }

    var prevEleParent = this.tempEle.closest('.OtherBookTypeRowParent');
    var prevEleClassList = prevEleParent.querySelector('.prevBooksIcon').classList;
    // if (scrollNavigation[activeIndex + 1]) {
    //   scrollNavigation[activeIndex].classList.remove('activeScrollBar');
    //   scrollNavigation[activeIndex + 1].classList.add('activeScrollBar');
    //   prevEleClassList.remove('hidePrevBooksIcon');

    // }

    // else {
      // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
      // scrollNavigation[0].classList.add('activeScrollBar');
                  // if (!this.ElectronService.IS_ELECTRON)
                  //   this.tempEle.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                  // else
                  //   this.tempEle.scrollLeft = 0;
                  // prevEleClassList.add('hidePrevBooksIcon');
                  // return;
    // }

    let maxScrollLeftOfEle = this.tempEle.scrollWidth - this.tempEle.clientWidth;
    if(maxScrollLeftOfEle > this.tempEle.scrollLeft){
      prevEleClassList.remove('hidePrevBooksIcon');

      if (!this.ElectronService.IS_ELECTRON)
      this.tempEle.scrollTo({ left: temp, top: 0, behavior: 'smooth' });
    else
      this.tempEle.scrollLeft = temp;
    }else{
      prevEleClassList.add('hidePrevBooksIcon');

      if (!this.ElectronService.IS_ELECTRON)
      this.tempEle.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    else
      this.tempEle.scrollLeft = 0;
    }

   


    // var interval = setInterval(() => {
    //   this.tempEle.scrollLeft = dis;
    //   dis = dis + 10;
    //   if (dis > temp) {
    //     clearInterval(interval);
    //   }
    // }, 20);
  }

  mouseEnter(event, type: any) {

    this.tempEle = event.target.querySelector('.booksParent');

    if (type == "recent") {
      if (this.panelRecent.nativeElement.scrollWidth > this.panelRecent.nativeElement.offsetWidth) {
        this.hideArrowButtons = true;
      }
    }
    else {
      if (this.tempEle.scrollWidth > this.tempEle.offsetWidth) {
        this.typeOfBook = type;
      }
    }

  }

  mouseLeave(event, type: any) {
    if (type == "recent") {
      this.hideArrowButtons = false;
    }
    else {
      this.typeOfBook = null;
    }
  }

  toggleRecentGridView() {
    if (this.showGridView) {
      this.gridToggleIcon = 'icon-BottomButton';
    } else {
      this.gridToggleIcon = 'icon-TopButton';
    }

    this.showGridView = !this.showGridView;
  }

  displayGridViewForBooks(index, type) {

    if (type == 'recent') {
      this.showAllShelfs = !this.showAllShelfs;
    }

    else {

      this.filterBooksArr = [];
      this.filterBooksArr.push(type);

      if (this.selectedGridIndex == index) {
        this.filterBooksArr = [];
        this.showAllGridView = true;
        this.selectedGridIndex = undefined;
        this.gridToggleIcon = 'icon-BottomButton';
      } else {
        this.showAllGridView = false;
        this.selectedGridIndex = index;
        this.gridToggleIcon = 'icon-TopButton';
      }
    }

  }


  onPdfObjChanged(ev) {
    this.showOverlayDivPdf = false
  }

  updateNextIcon(count, ind, state) {

    var gridIndex = ind;
    if (state == 'all' && this.data.this.displayRecents && this.allRecentFiles.length) {
      ind = ind + 1;
    }

    if (this.repeatingBookTypes) {
      let a = this.repeatingBookTypes.nativeElement.querySelectorAll('.OtherBookTypeRowParent');
      let gridIcon = this.repeatingBookTypes.nativeElement.querySelectorAll('.gridViewIconForBooks');
      if (a[ind]) {
        var classList = a[ind].querySelector('.nextBooksIcon').classList;
        var gridIconClassList = gridIcon[gridIndex].classList;
        if ((170 * count) > this.availableViewableWidth) {
          classList.remove('hidePrevBooksIcon');
          gridIconClassList.remove('hidePrevBooksIcon');
        } else {
          classList.add('hidePrevBooksIcon');
          gridIconClassList.add('hidePrevBooksIcon');
        }
      }

    }
  }


  updateRecentNextIcon(count, ind, state) {


    if (this.repeatingBookTypes) {

      let a = this.repeatingBookTypes.nativeElement.querySelectorAll('.OtherBookTypeRowParent');

      let gridIcon = this.repeatingBookTypes.nativeElement.querySelectorAll('.gridViewIconForBooks');

      if (a[ind]) {
        var classList = a[ind].querySelector('.nextBooksIcon').classList;

        var gridIconClassList ;
        if(gridIcon.length){
          gridIconClassList = gridIcon[ind].classList;
        }
        
        if ((170 * count) > this.availableViewableWidth) {
          classList.remove('hidePrevBooksIcon');

          if(gridIconClassList)
          gridIconClassList.remove('hidePrevBooksIcon');

        } else {
          classList.add('hidePrevBooksIcon');

          if(gridIconClassList)
          gridIconClassList.add('hidePrevBooksIcon');

        }
      }
    }
  }


  updateScrollNavbars() {
    if (this.parentEle) {
      this.availableViewableWidth = this.parentEle.nativeElement.offsetWidth - 15;  // 15 is offset
      this.totalScrollbarWidth = this.parentEle.nativeElement.scrollLeft;
    }
    else {
      this.availableViewableWidth = Number(localStorage.availableViewableWidth)
    }


    if (this.availableViewableWidth < 0) {
      this.availableViewableWidth = Number(localStorage.availableViewableWidth)
    }
    let parentsOfBooks = []
    if (this.repeatingBookTypes) {
      parentsOfBooks = this.repeatingBookTypes.nativeElement.querySelectorAll('.OtherBookTypeRowParent')
    }

    for (var i = 0; i < parentsOfBooks.length; i++) {
      // var scrollNavigation = parentsOfBooks[i].querySelectorAll('.booksNavigation');
      // for (var j = 0; j < scrollNavigation.length; j++) {
      //   scrollNavigation[j].classList.remove('activeScrollBar');
      //   scrollNavigation[0].classList.add('activeScrollBar');
      // }
      if (!this.ElectronService.IS_ELECTRON)
        parentsOfBooks[i].querySelector('.booksParent').scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      else
        parentsOfBooks[i].querySelector('.booksParent').scrollLeft = 0;
    }

    var prevIconEles = this.ele.nativeElement.querySelectorAll('.prevBooksIcon');
    for (var i = 0; i < prevIconEles.length; i++) {
      prevIconEles[i].classList.add('hidePrevBooksIcon');

    }

  }


  showBookDetails(popupParams: any, ev, width, height, book, ShelfId): void {
    this.bookInfoShelfId = ShelfId;
    if (book.bookCategory == 1) {
      popupParams.loadDirective = CreatedBookInfoComponent;
    }
    else {
      popupParams.loadDirective = BookdetailsComponent;
    }

    this.globalPopupPara = popupParams;
    this.globalPopupPara.showPopup = true;
    this.globalPopupPara.ev = ev;
    popupParams.height = height;
    popupParams.width = width;
    popupParams.arrowPos = 150;
    popupParams.direction = "left";
    if (ev.clientX > window.innerWidth * 0.6) {
      popupParams.direction = "right";
    }
    popupParams.bookDetals = true;
    this.selBookDetals = book;

  }




  sortData(sort: Sort, ind: number, order) {

    const data = this.booksData.bookList[ind].data.slice();

    if (!sort.active || sort.direction == '') {


      this.booksData.bookList[ind].data = this.prevStateArr[ind].data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'title': return this.compare(a.title, b.title, isAsc);
        // bookCategoryTypes[bookCategoeyEnums[puchases.bookType]]
        case 'type': return this.compare(this.bookCategoryTypes[bookCategoeyEnums[a.bookType]], this.bookCategoryTypes[bookCategoeyEnums[b.bookType]], isAsc);
        // case 'type': return this.compare(a.bookType, b.bookType, isAsc);
        case 'last seen': return this.compare(a.lastSeenDate, b.lastSeenDate, isAsc);

        case 'author': return this.compare(a.author, b.author, isAsc);
        default: return 0;

      }

    });
    this.booksData.bookList[ind].data = this.sortedData

  }


  compare(a, b, isAsc) {

    if (a == b) {

    }
    else {

      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
  }



  applyFilterforBooks(popupParams: any, ev, width, height): void {
    let bookfilterArr = [];
    this.booksData.bookList.forEach(key => {
      if (key.data.length) {
        bookfilterArr.push(key.shelfName)
      }
    });

    if (!bookfilterArr.length) {
      return;
    }

    popupParams.loadDirective = BooksFilterComponent;
    this.globalPopupPara = popupParams;
    this.globalPopupPara.showPopup = true;
    this.globalPopupPara.ev = ev;
    popupParams.height = height;
    popupParams.width = width;
    popupParams.arrowPos = 170;
    popupParams.filterList = bookfilterArr;
    popupParams.direction = "top";
this.allFiltersList = bookfilterArr;
  }

  updateFilter(ind, Arr) {
    this.filterBooksArr = Arr;
    this.filterUpdatingState = true
  if(this.allFiltersList.length == Arr.length){
    this.filterBooksArr = [];
    Arr = [];
    this.filterUpdatingState = true;
    this.showAllGridView = true;
    this.gridToggleIcon = 'icon-BottomButton';
    this.selectedGridIndex = undefined;
     return;
  }

    if (Arr.length == 1) {
      let index = _.findIndex(this.booksData.bookList, function (o) { return o.shelfName == Arr[0]; });
      this.selectedGridIndex = undefined;
      this.displayGridViewForBooks(index, Arr[0]);
    }
    else if (!Arr.length) {
      // this.showAllGridView = true;
      // this.gridToggleIcon = 'icon-BottomButton';
      // this.selectedGridIndex = undefined;
      this.filterBooksArr = [];
      this.filterUpdatingState = false
    }
    else {
      this.showAllGridView = false;
      this.gridToggleIcon = 'icon-BottomButton';
      this.selectedGridIndex = undefined;
    }
  }

  isSelectedGridIndAvl(name) {
    let index = _.findIndex(this.filterBooksArr, function (o) { return o == name; });
    if (index != -1) {
      return true;
    } else {
      return false;
    }
  }

  displayFilteredBooks(type) {
    if (this.filterBooksArr.length == 0) {
      return true;
    }
    else {
      let ind = _.findIndex(this.filterBooksArr, function (o) { return o == type.shelfName; });
      if (ind != -1) {
        return true;
      } else {
        return false;
      }

    }
  }

  assignDragData(book, folderName, id) {

    if(folderName == 'Favourites'){
      return;
    }
    
    let temp = {
      book: book,
      draggingFrom: folderName,
      draggingFromId: id
    };
    return temp;
  }


  onItemDrop(ev, obj, droppedAt) {

    if (!ev.dragData.book) {
      return;
    }

    var temp = _.isEqual(obj, ev.dragData.book);
    if (temp) {
      return;
    }

    this.draggedBook = ev.dragData.book;
    this.draggedBookFrom = ev.dragData.draggingFrom;
    this.draggedBookFromId = ev.dragData.draggingFromId
    this.droppedBookAt = droppedAt;
    this.droppedOnBook = obj;
    // this.draggingFrom = ev.dragData.draggingFrom;

    var myCompThis = parent.window.document['mycompthis'];
    let information = { 'name': 'New Shelf', data: myCompThis.myContentElements, state: 'creatingFolder' }
    let dialogRef = this.dialog.open(createFolderBooks, {
      width: '315px',
      data: information,
      disableClose: false
    });

    var self = this;

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        self.addingNewFolder(result);
      }
    });

  }
  addingNewFolder(name) {
    var self = this;
    var timestamp = Math.round(new Date().getTime() / 1000);
    var id = Constants.USER + "." + timestamp + ".shelf";
    var shelfObj = new Shelf();
    shelfObj.bookIds = [];
    shelfObj.createdAt = timestamp;
    shelfObj.owner = Constants.USER;
    shelfObj.title = name;
    shelfObj.shelfType = "created";
    shelfObj._id = id;
    this.lastCreatedShelf = shelfObj;

    var ind = parent.window.document['mycompthis'].selectedTabList;
    if (ind == undefined) {
        ind = 0;
    }
    else {
        ind = ind + 1
    }

    this.pouchservice.createShelf(shelfObj).then(function(res){
      self.pouchservice.alternateGetShelfData(ind);
    })

  }

  updateListOfShlefs(docs) {
    var self = this;
    var ev = {
      book: this.draggedBook,
      draggingFrom: this.draggedBookFrom,
      draggingFromId: this.draggedBookFromId
    }

    var ev1 = {
      book: self.droppedOnBook,
      draggingFrom: self.droppedBookAt.shelfName,
      draggingFromId: self.droppedBookAt._id
    }

    this.pouchservice.dragAndDropBookOnOtherBook(ev, self.lastCreatedShelf, false).then(function (res) {
      if (!res) {
        self.pouchservice.dragAndDropBookOnOtherBook(ev1, self.lastCreatedShelf, true).then(function(res){
          self.lastCreatedShelf = undefined
        })
      }
    })

  }


  addMyTemplateCoverPage(book) {
    var myCompThis = parent.window.document['mycompthis'];
    this.myTemplatesArr = myCompThis.cteatedMytemplates;

    var index = _.findIndex(this.myTemplatesArr, function (o: any) { return o._id == book.templateId; });
    if (index > -1) {
      return this.myTemplatesArr[index].cover.thumbUrl;
    }
  }

  getReadedAreaWidth(book) {
    return (Number(book.lastOpenedPage)/book.pageCount)*100+'%';
  }

}


@Component({
  selector: 'app-createFolderBooks',
  templateUrl: '../mycontent/newFolder.popup.html',
  styleUrls: ['../shelf.component.css', '../mycontent/mycontent.component.css']
})
export class createFolderBooks {
  newFolderTitle;
  isAvailable;
  showError = false;
  templateAsEnrichmentObj = {
    showPopup: false
  }
  constructor(
    public dialogRef: MatDialogRef<createFolderBooks>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  updateNewFolderName(ev, name) {
    if (ev.which == 13) {
      this.onYesClick(name);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(name) {
    this.isAvailable = undefined;

    this.isFolderNameAlreadyExist(this.data.data, name);

    if (this.isAvailable || name == ''|| !name) {
      this.showError = true;
      return;
    }

    this.dialogRef.close(name);
  }

  isFolderNameAlreadyExist(data, name) {
    if (name == 'Purchases' || name == 'Creations' || name == 'Imports' || name == 'Favourites' || name == 'Favorites') {
      this.isAvailable = true;
    }
  }


}


// WEBPACK FOOTER //
// ./src/app/shelf/all/all.component.ts